import { Fragment, useEffect, useState } from "react";
import { RouteComponentProps } from "../../models/RouteComponent";
import useApiService from "../../hooks/useApiService";
import { Card } from "primereact/card";

import { Badge } from "primereact/badge";
import { useNavigate } from "react-router-dom";
import {
  ActionPlanData,
  Summary,
  TaskType,
} from "../../models/actionplan-for-compliance.interface";

export default function TaskView(props: RouteComponentProps) {
  const navigate = useNavigate();

  const [summary, setSummary] = useState<Summary>({
    critical: "0",
    warnings: "0",
    pending: "0",
    compliance: "0",
  });
  const [taskTypes, setTaskTypes] = useState<TaskType[]>([]);

  const { loading } = useApiService<ActionPlanData>({
    method: "GET",
    url: "task-dashboard",
    apiName: "core",
    onSuccess(data) {
      setSummary(data.summary);
      setTaskTypes(data.taskTypes);
    },
  });

  useEffect(() => {
    props.setGlobalLoader(loading);
  }, [props, loading]);

  const [responsibleFilter, setResponsibleFilter] = useState("Both");
  const [sizeFilter, setSizeFilter] = useState("All");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const responsibleOptions = [
    { label: "Both", value: "Both" },
    { label: "Me", value: "Me" },
    { label: "Others", value: "Others" },
  ];

  const sizeOptions = [
    { label: "All", value: "All" },
    { label: "Small", value: "Small" },
    { label: "Medium", value: "Medium" },
    { label: "Large", value: "Large" },
  ];

  const header = (
    icons: string,
    title: string,
    badge: string,
    color: string,
    badgeColor: string
  ) => (
    <div
      style={{ padding: 10, backgroundColor: color, borderRadius: "10px 10px 0 0" }}
      className="flex items-center gap-2"
    >
      <i className={`pi ${icons}`} style={{ fontSize: 20, color: "black" }}></i>
      <label style={{ width: "100%", color: "black", fontWeight: "bold" }}>{title}</label>
      <Badge value={badge} style={{ backgroundColor: badgeColor, color: "black" }} />
    </div>
  );

  const renderTaskListItem = (
    title: string,
    child: { type: string; label: string; badge: string; color: string; badgeColor: string },
    index: number
  ) => {
    const { type, label, badge, color, badgeColor } = child;
    return (
      <div
        onClick={() => {
          // Navigate directly to /non-compliance for non-compliance tracker
          if (type === 'checklist_non_compliance_tracker') {
            navigate('/non-compliance');
          } else {
            navigate(`/task-table/${title}/${encodeURIComponent(label)}/${type}`);
          }
        }}
        key={`${title}-${index}`}
        style={{
          backgroundColor: color,
          padding: "5px 0",
          borderLeft: `3px solid ${badgeColor}`,
          borderRadius: 8,
          marginBottom: 15,
          cursor: "pointer",
        }}
        className="flex justify-between items-center"
      >
        <div
          style={{ padding: "5px 10px", width: "100%", fontWeight: "bold" }}
          className="flex items-center gap-2"
        >
          <div>{label}</div>
        </div>
        <div style={{ padding: "5px 10px" }}>
          <Badge value={badge} style={{ backgroundColor: badgeColor, color: "black" }} />
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      {/* <Card>
        <div className="flex gap-4">
          <div className="flex-1">
            <label className="block mb-2">Responsible</label>
            <Dropdown
              value={responsibleFilter}
              options={responsibleOptions}
              onChange={(e) => setResponsibleFilter(e.value)}
              className="w-full"
            />
          </div>
          <div className="flex-1">
            <label className="block mb-2">Size</label>
            <Dropdown
              value={sizeFilter}
              options={sizeOptions}
              onChange={(e) => setSizeFilter(e.value)}
              className="w-full"
            />
          </div>
          <div className="flex-1">
            <label className="block mb-2">Start Date</label>
            <Calendar
              value={startDate}
              onChange={(e) => setStartDate(e.value as Date)}
              placeholder="yyyy/mm/dd"
              className="w-full"
            />
          </div>
          <div className="flex-1">
            <label className="block mb-2">End Date</label>
            <Calendar
              value={endDate}
              onChange={(e) => setEndDate(e.value as Date)}
              placeholder="yyyy/mm/dd"
              className="w-full"
            />
          </div>
          <div className="flex-none">
            <label className="block mb-2">&nbsp;</label>
            <Button label="Refresh" icon="pi pi-refresh" className="p-button-primary" />
          </div>
        </div>
      </Card> */}

      <div className="flex gap-4 mt-4">
        <div className="flex-1">
          <Card pt={{ body: { style: { padding: "0px 15px" } } }}>
            <div className="flex justify-between items-start">
              <div>
                <div className="text-sm text-gray-600 mb-1">Total Critical Items</div>
                <div className="text-2xl font-bold" style={{ color: "#f05454" }}>
                  {summary.critical}
                </div>
              </div>
              <div style={{ margin: "auto", marginRight: 0 }}>
                <i
                  className="pi pi-exclamation-triangle"
                  style={{ color: "#f05454", fontSize: "2rem" }}
                ></i>
              </div>
            </div>
          </Card>
        </div>
        <div className="flex-1">
          <Card pt={{ body: { style: { padding: "0px 15px" } } }}>
            <div className="flex justify-between items-start">
              <div>
                <div className="text-sm text-gray-600 mb-1">Warnings</div>
                <div className="text-2xl font-bold" style={{ color: "#f59e0b" }}>
                  {summary.warnings}
                </div>
              </div>
              <div style={{ margin: "auto", marginRight: 0 }}>
                <i
                  className="pi pi-exclamation-circle"
                  style={{ color: "#f59e0b", fontSize: "2rem" }}
                ></i>
              </div>
            </div>
          </Card>
        </div>
        <div className="flex-1">
          <Card pt={{ body: { style: { padding: "0px 15px" } } }}>
            <div className="flex justify-between items-start">
              <div>
                <div className="text-sm text-gray-600 mb-1">Pending Actions</div>
                <div className="text-2xl font-bold" style={{ color: "#3b82f6" }}>
                  {summary.pending}
                </div>
              </div>
              <div style={{ margin: "auto", marginRight: 0 }}>
                <i className="pi pi-clock" style={{ color: "#3b82f6", fontSize: "2rem" }}></i>
              </div>
            </div>
          </Card>
        </div>
        <div className="flex-1">
          <Card pt={{ body: { style: { padding: "0px 15px" } } }}>
            <div className="flex justify-between items-start">
              <div>
                <div className="text-sm text-gray-600 mb-1">Compliance Rate</div>
                <div className="text-2xl font-bold" style={{ color: "#27c661" }}>
                  {summary.compliance}%
                </div>
              </div>
              <div style={{ margin: "auto", marginRight: 0 }}>
                <i
                  className="pi pi-check-circle"
                  style={{ color: "#27c661", fontSize: "2rem" }}
                ></i>
              </div>
            </div>
          </Card>
        </div>
      </div>

      <div className="flex flex-wrap gap-3 mt-3">
        {taskTypes?.map((item, index) => (
          <div
            className="flex-grow min-w-0"
            key={`task-item-${index}`}
            style={{
              flexBasis: "calc(33.333% - 0.75rem)",
              maxWidth: "calc(33.333% - 0.75rem)",
            }}
          >
            <Card
              header={header(item.icon, item.label, item.badge, item.color, item.badgeColor)}
              style={{ height: "100%" }}
              pt={{ body: { style: { padding: "0px 15px" } } }}
            >
              {item.child.map((child, childIndex) =>
                renderTaskListItem(item.label, child, childIndex)
              )}
            </Card>
          </div>
        ))}
      </div>
    </Fragment>
  );
}
